import { render, staticRenderFns } from "./profile-view-documents.vue?vue&type=template&id=b7f41cca&scoped=true&"
import script from "./profile-view-documents.vue?vue&type=script&lang=js&"
export * from "./profile-view-documents.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-documents.vue?vue&type=style&index=0&id=b7f41cca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f41cca",
  null
  
)

export default component.exports